import React from 'react';
import { WorkflowLevelBlockWrapper } from '@styles/Admin-tools/Workflows/WorkflowStepStyles';
import { IWorkflowStep } from '../../types';
import WorkflowLevel from './components/WorkflowLevel/WorkflowLevel';

type TWorkflowLevelBlockProps = {
  currentStepsList: IWorkflowStep[];
  handleSelectStep: (data: IWorkflowStep) => void;
  handleAddStepButtonClick: (id: string) => void;
  handleAddStep: (id: string) => void;
  handleEditParentStep: (id: string | null, parentStepId: string | null) => void;
  setWorkflowLevel: React.Dispatch<React.SetStateAction<boolean>>;
};

const WorkflowLevelBlock = ({
  handleAddStepButtonClick,
  handleSelectStep,
  handleAddStep,
  handleEditParentStep,
  currentStepsList,
  setWorkflowLevel,
}: TWorkflowLevelBlockProps) => {
  return (
    <WorkflowLevelBlockWrapper>
      <WorkflowLevel
        order={1}
        parentStepId="root"
        steps={currentStepsList}
        setWorkflowLevel={setWorkflowLevel}
        handleSelectStep={handleSelectStep}
        handleAddStep={handleAddStep}
        handleAddStepButtonClick={handleAddStepButtonClick}
        handleEditParentStep={handleEditParentStep}
      />
    </WorkflowLevelBlockWrapper>
  );
};

export default WorkflowLevelBlock;
